import {paramsFromLocation} from '@yandex-delivery/utils/url'

export const isSellAndBuy = () => {
  const params = paramsFromLocation()

  return params.service === 'safedeal'
}
